import './Chip.scss';

interface ChipProps {
  href: string;
  label: string;
  mobile?: boolean;
  dataEm: string;
  backgroundColor?: string;
  fontColor?: string;
}

const Chip = ({ label, href, mobile = false, dataEm, backgroundColor, fontColor }: ChipProps) => {
  return (
    <a
      href={href}
      className="trending-search-chip hmf-display-flex hmf-justify-content-center hmf-px-xxs hmf-px-md-xs hmf-text-decoration-none"
      {...((backgroundColor || fontColor) && {
        style: {
          ...(backgroundColor && { backgroundColor }),
          ...(fontColor && { color: fontColor }),
        },
      })}>
      <span
        className="hmf-body-m hmf-display-flex hmf-align-items-center"
        aria-label={label}
        data-em={dataEm}>
        {label}
      </span>
    </a>
  );
};

export default Chip;
